import { Phone, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer py-16" data-testid="footer">
      <div className="container-custom">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Company info */}
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="w-10 h-10 bg-white flex items-center justify-center">
                <span className="text-[#2C3E50] font-heading font-bold text-lg">F</span>
              </div>
              <span className="font-heading font-semibold text-white text-lg">
                Fönstermålning
              </span>
            </div>
            <p className="text-white/80 mb-6 leading-relaxed">
              Professionell fönstermålning i Stockholm med omnejd. 
              Vi förlänger livslängden på dina fönster med kvalitet och omsorg.
            </p>
            <p className="text-white/60 text-sm">
              En tjänst från Vi Målar AB
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-heading font-semibold text-white text-lg mb-6">
              Snabblänkar
            </h4>
            <ul className="space-y-3">
              {[
                { href: '#benefits', label: 'Fördelar med fönstermålning' },
                { href: '#why-us', label: 'Varför välja oss' },
                { href: '#process', label: 'Så går det till' },
                { href: '#faq', label: 'Vanliga frågor' },
                { href: '#contact', label: 'Kontakta oss' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-white/80 hover:text-white transition-colors duration-200"
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-white text-lg mb-6">
              Kontakt
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="tel:08-254604"
                  className="flex items-center gap-3 text-white/80 hover:text-white transition-colors duration-200"
                  data-testid="footer-phone-link"
                >
                  <Phone className="w-5 h-5 flex-shrink-0" />
                  08-25 46 04
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@vimalar.se"
                  className="flex items-center gap-3 text-white/80 hover:text-white transition-colors duration-200"
                  data-testid="footer-email-link"
                >
                  <Mail className="w-5 h-5 flex-shrink-0" />
                  info@vimalar.se
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/80">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span>Stockholm med omnejd</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-white/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/60 text-sm">
            © {currentYear} Vi Målar AB. Alla rättigheter förbehållna.
          </p>
          <div className="flex gap-6 text-sm">
            <a
              href="https://vimalar.se"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/60 hover:text-white transition-colors duration-200"
            >
              vimalar.se
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
